import React from "react";
import { IconProps } from "./IconProps";

const ArrowCircleUpRightIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 3.25C13.4783 3.25 11.0132 3.99777 8.91648 5.39876C6.81975 6.79975 5.18555 8.79103 4.22054 11.1208C3.25552 13.4505 3.00303 16.0141 3.49499 18.4874C3.98695 20.9607 5.20127 23.2325 6.98439 25.0156C8.76751 26.7987 11.0393 28.0131 13.5126 28.505C15.9859 28.997 18.5495 28.7445 20.8792 27.7795C23.209 26.8144 25.2003 25.1802 26.6012 23.0835C28.0022 20.9868 28.75 18.5217 28.75 16C28.746 12.6197 27.4015 9.379 25.0112 6.98877C22.621 4.59854 19.3803 3.25397 16 3.25ZM16 27.25C13.775 27.25 11.5999 26.5902 9.74984 25.354C7.89978 24.1179 6.45784 22.3609 5.60636 20.3052C4.75487 18.2495 4.53208 15.9875 4.96617 13.8052C5.40025 11.6229 6.47171 9.61839 8.04505 8.04505C9.61839 6.47171 11.6229 5.40025 13.8052 4.96617C15.9875 4.53208 18.2495 4.75487 20.3052 5.60636C22.3609 6.45784 24.1179 7.89978 25.354 9.74984C26.5902 11.5999 27.25 13.775 27.25 16C27.2467 18.9827 26.0604 21.8422 23.9513 23.9513C21.8422 26.0604 18.9827 27.2467 16 27.25ZM20.75 12V18C20.75 18.1989 20.671 18.3897 20.5303 18.5303C20.3897 18.671 20.1989 18.75 20 18.75C19.8011 18.75 19.6103 18.671 19.4697 18.5303C19.329 18.3897 19.25 18.1989 19.25 18V13.8112L12.53 20.53C12.3878 20.6625 12.1998 20.7346 12.0055 20.7312C11.8112 20.7277 11.6258 20.649 11.4884 20.5116C11.351 20.3742 11.2723 20.1888 11.2688 19.9945C11.2654 19.8002 11.3375 19.6122 11.47 19.47L18.1887 12.75H14C13.8011 12.75 13.6103 12.671 13.4697 12.5303C13.329 12.3897 13.25 12.1989 13.25 12C13.25 11.8011 13.329 11.6103 13.4697 11.4697C13.6103 11.329 13.8011 11.25 14 11.25H20C20.1989 11.25 20.3897 11.329 20.5303 11.4697C20.671 11.6103 20.75 11.8011 20.75 12Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default ArrowCircleUpRightIcon;
